module.exports = __webpack_public_path__ + "static/media/logo_pdf_bold.8a344ace.png";